import { PlanLimitExceededSource } from "store/entities/subscriptions";
import { ActionsUnion, createAction } from "store/helper";

export enum SubscriptionViewActionsNames {
  SET_FOCUSED_COLUMN = "VIEWS/SUBSCRIPTION/SET_FOCUSED_COLUMN",
  CLOSE_UPSELL_MODAL = "VIEWS/SUBSCRIPTION/CLOSE_UPSELL_MODAL",
  OPEN_UPSELL_MODAL = "VIEWS/SUBSCRIPTION/OPEN_UPSELL_MODAL",
}

export const SubscriptionViewActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setFocusedColumn: (focusedColumn: number) =>
    createAction(SubscriptionViewActionsNames.SET_FOCUSED_COLUMN, { focusedColumn }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  closeUpsellModal: () => createAction(SubscriptionViewActionsNames.CLOSE_UPSELL_MODAL),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  openUpsellModal: ({ source }: { source: PlanLimitExceededSource }) =>
    createAction(SubscriptionViewActionsNames.OPEN_UPSELL_MODAL, { source }),
};

export type SubscriptionViewAction = ActionsUnion<typeof SubscriptionViewActions>;
